import React from 'react';
import { Link } from 'react-router-dom';
import t from '@guestyci/localize/t.macro';
import { Button, Stack } from '@guestyci/arc';
import { GUESTY_HELP_TROUBLESHOOTING_LOGIN_URL } from 'utils/consts';
import { isSafeUrl } from '../utils/safeNavigate';

const ForgotHelpLinks = ({
  helpUrl = GUESTY_HELP_TROUBLESHOOTING_LOGIN_URL,
  disabled = false,
}) => {
  return (
    <Stack direction="row" justify="between" align="center" className="gst-w-full">
      <Button
        asChild
        variant="plain-primary"
        size="sm"
        disabled={disabled}
        className="gst-p-0"
      >
        {disabled ? (
          <a aria-disabled="true">{t('Forgot password?')}</a>
        ) : (
          <Link to="/forgot">{t('Forgot password?')}</Link>
        )}
      </Button>
      <Button
        asChild
        variant="plain-primary"
        size="sm"
        disabled={disabled}
        className="gst-p-0"
      >
        {disabled ? (
          <a aria-disabled="true" target="_blank" rel="noopener noreferrer">
            {t('Need help?')}
          </a>
        ) : (
          <a href={isSafeUrl(helpUrl) ? helpUrl : undefined} target="_blank" rel="noopener noreferrer">
            {t('Need help?')}
          </a>
        )}
      </Button>
    </Stack>
  );
};

export default ForgotHelpLinks;
